import { ApolloCache, gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';
import { goalFragment } from '../fragments/goal';
import { CreateCategoryMutation, GetQuestsQuery, GetQuestsQueryVariables } from '../generated/graphql';
import { getQuestsQuery } from '../queries/quest';
import { forEachPrimaryQuestsQuery } from './cacheHelpers';

export const createCategoryMutation = gql`
    ${categoryFragment}
    ${goalFragment}

    mutation CreateCategory(
        $name: String!
        $description: String
        $icon: String!
        $iconColor: String!
        $parentId: String
        $goalEnabled: Boolean
        $templateId: String
        $system: Boolean
    ) {
        createCategory(
            data: {
                name: $name
                description: $description
                icon: $icon
                iconColor: $iconColor
                parentId: $parentId
                goalEnabled: $goalEnabled
                templateId: $templateId
                system: $system
            }
        ) {
            category {
                ...CategoryFields
            }
            goal {
                ...GoalFields
            }
        }
    }
`;

const updateGetQuests = (cache: ApolloCache<any>, { data }: { data?: CreateCategoryMutation | null }) => {
    if (!data?.createCategory) {
        return;
    }

    const newCategory = data.createCategory.category;
    forEachPrimaryQuestsQuery(cache, (vars, existingData) => {
        if (!existingData?.categories) {
            return;
        }

        const categoryExists = existingData.categories.some(c => c.id === newCategory.id);
        if (categoryExists) return;

        const newCategories = [...existingData.categories, { ...newCategory }];
        const newGoals = data.createCategory.goal ? [...(existingData.goals || []), data.createCategory.goal] : existingData.goals || [];

        cache.writeQuery<GetQuestsQuery, GetQuestsQueryVariables>({
            query: getQuestsQuery,
            variables: vars,
            data: { ...existingData, categories: newCategories, goals: newGoals },
        });
    });
};

export function createCategoryCache(cache: ApolloCache<any>, mutationData: { data?: CreateCategoryMutation | null }) {
    updateGetQuests(cache, mutationData);
}
